import MainImg from "../assats/Rajhans Empire office-2.webp";
import gallary from "../assats/gallary2.webp";
import gallary1 from "../assats/gallary3.webp";
import gallary2 from "../assats/image2.webp";
import gallary3 from "../assats/gallary3.webp";
import gallary4 from "../assats/gallary4.webp";
import gallary5 from "../assats/gallary5.webp";
import gallary6 from "../assats/gallary6.webp";
import gallary7 from "../assats/gallary7.webp";
import gallary8 from "../assats/gallary8.webp";
import gallary9 from "../assats/gallary9.webp";
import gallary10 from "../assats/gallary10.webp";
import gallary11 from "../assats/gallary11.webp";
import gallary12 from "../assats/gallary12.webp";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { API_URL } from "../config";
import axios from "axios";
import { SlideshowLightbox } from 'lightbox.js-react'
import 'lightbox.js-react/dist/index.css'
import { Gallery } from "react-grid-gallery";

const images = [
    {
        src: "https://c2.staticflickr.com/9/8817/28973449265_07e3aa5d2e_b.jpg",
        width: 320,
        height: 174,
        isSelected: true,
        caption: "After Rain (Jeshu John - designerspics.com)",
    },
    {
        src: "https://c2.staticflickr.com/9/8356/28897120681_3b2c0f43e0_b.jpg",
        width: 320,
        height: 212,
        tags: [
            { value: "Ocean", title: "Ocean" },
            { value: "People", title: "People" },
        ],
        alt: "Boats (Jeshu John - designerspics.com)",
    },
    {
        src: "https://c4.staticflickr.com/9/8887/28897124891_98c4fdd82b_b.jpg",
        width: 320,
        height: 212,
    },
];

const ProjectDetail = () => {
    const navigate = useNavigate();
    const { projectid } = useParams();
    const [isDetail, setIsDetail] = useState([]);
    const [WorkSpaceImg, setWorkSpaceImg] = useState([]);
    const [recentPost, setRecentPost] = useState([]);


    const projectDetailData = () => {
        const url = `${API_URL}/admin/post/view_single_post/${projectid}`;
        const token = localStorage.getItem("JWT_Token");

        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        axios.get(url, config)
            .then(response => {
                setIsDetail(response?.data?.record);
                setWorkSpaceImg(response.data?.record?.work_space_image)
            })
            .catch(error => {
                console.log("Error", error);
            })
    }

    const recentPostData = () => {
        const url = `${API_URL}/admin/post/view_recent_post`;

        axios.get(url)
            .then(response => {
                setRecentPost(response.data.record);
            })
            .catch(error => {
                // Handle error
                console.error("Error:", error.response.status, error.response.statusText);
                console.error(error.response.data);
            });
    }

    useEffect(() => {
        projectDetailData();
        recentPostData();
    }, []);

    return (
        <>
            <div className="">
                <div className="p-20 bg-[#A35733]">
                    <p className="text-center text-[50px] text-white font-semibold">{isDetail?.title}</p>
                    <p className="text-center text-[20px] py-5 text-white tracking-wider">{isDetail?.post_type}</p>
                </div>
                <div>
                    <div className="lg:container md:mx-auto">
                        <div className="grid grid-cols-1 lg:grid-cols-2 lg:px-20 gap-20 m-10">
                            <div>
                                <div>
                                    <p className="text-[23px] pt-5 tracking-wider font-medium">Project Completion Year </p>
                                    <p className="text-[17px] not-italic tracking-wider text-[#676767] mt-5">{isDetail?.project_complet_year}</p>
                                </div>
                                <div>
                                    <p className="text-[23px] pt-5 tracking-wider font-medium">Project Location</p>
                                    <p className="text-[17px] not-italic tracking-wider text-[#676767] mt-5">{isDetail?.project_location}</p>
                                </div>
                                <div>
                                    <p className="text-[23px] pt-5 tracking-wider font-medium">Program </p>
                                    <p className="text-[17px] not-italic tracking-wider text-[#676767] mt-5">{isDetail?.program}</p>
                                </div>
                                <div>
                                    <p className="text-[23px] pt-5 tracking-wider font-medium">Project Description </p>
                                    <p className="text-[17px] not-italic tracking-wider text-[#676767] mt-5">{isDetail?.description}</p>
                                </div>
                            </div>
                            <div>
                                <img src={`${API_URL}${isDetail?.postImage}`} className="bg-[#676767] w-10/12 m-auto" />
                            </div>
                        </div>
                        <div className="m-10 lg:px-20">
                            <p className="text-[17px] not-italic tracking-wider text-[#676767] mt-5">{isDetail?.description_1}</p>
                            <p className="text-[17px] not-italic tracking-wider text-[#676767] mt-5">{isDetail?.description_2}</p>
                        </div>
                        <div className="m-10 lg:px-20">
                            {/* <div className="grid grid-cols-1 lg:grid-cols-2 lg:space-x-10">
                                {isDetail?.work_space_image?.map((item) => {
                                    return (
                                        <>
                                            <img src={`${ API_URL }${ item }`} className="h-auto m-auto  rounded-lg shadow-xl dark:shadow-gray-800" />
                                            <img src={`${ API_URL }${ item }`} className="h-auto m-auto  rounded-lg shadow-xl dark:shadow-gray-800" />
                                            <img src={`${ API_URL }${ item }`} className="h-auto m-auto  rounded-lg shadow-xl dark:shadow-gray-800" />
                                        </>
                                    )
                                })}
                            </div> */}

                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                                {isDetail?.work_space_image?.map((item) => {
                                    return (
                                        <>
                                            <SlideshowLightbox className="container mx-auto">
                                                <img id="image1" src={`${API_URL}${item}`} className="h-80 w-80 m-auto rounded-lg shadow-xl dark:shadow-gray-800" />
                                            </SlideshowLightbox >
                                        </>
                                    )
                                })}
                            </div>

                            <p className="text-[17px] not-italic tracking-wider text-[#676767] mt-10">
                                {isDetail?.description_3}
                            </p>

                        </div>
                        <div className="m-10 lg:px-20">
                            <div className="container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mx-auto">

                                {isDetail?.gallary_image?.map((item) => {
                                    return (
                                        <>
                                            <SlideshowLightbox className="container mx-auto">
                                                <img src={`${API_URL}${item}`} className="h-96 w-96" />
                                            </SlideshowLightbox>
                                        </>
                                    )
                                })}
                            </div>

                            {/* <div className="column">
                                    <img src={gallary8} style={{ width: "100%" }} />
                                    <img src={gallary9} style={{ width: "100%" }} />
                                    <img src={gallary10} style={{ width: "100%" }} />
                                    <img src={gallary11} style={{ width: "100%" }} />
                                    <img src={gallary12} style={{ width: "100%" }} />
                                    <img src={gallary1} style={{ width: "100%" }} />
                                </div>
                                <div className="column">
                                    <img src={gallary12} style={{ width: "100%" }} />
                                    <img src={gallary2} style={{ width: "100%" }} />
                                    <img src={gallary3} style={{ width: "100%" }} />
                                    <img src={gallary4} style={{ width: "100%" }} />
                                    <img src={gallary5} style={{ width: "100%" }} />
                                    <img src={gallary6} style={{ width: "100%" }} />
                                    <img src={gallary7} style={{ width: "100%" }} />
                                </div>
                                <div className="column">
                                    <img src={gallary8} style={{ width: "100%" }} />
                                    <img src={gallary9} style={{ width: "100%" }} />
                                    <img src={gallary10} style={{ width: "100%" }} />
                                    <img src={gallary11} style={{ width: "100%" }} />
                                    <img src={gallary12} style={{ width: "100%" }} />
                                    <img src={gallary1} style={{ width: "100%" }} />
                                </div> */}


                            <section class="py-6 sm:py-12  text-gray-800 ">
                                <div class="container p-6 mx-auto space-y-8">
                                    <div class="space-y-2 text-center">
                                        <h2 class="text-3xl font-bold">Recent Post</h2>
                                    </div>
                                    {/* <p className="flex justify-end cursor-pointer" onClick={() => navigate("/allpost")}>All Post</p> */}

                                    <div class="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-3">
                                        {recentPost.map((item) => {
                                            return (
                                                <>
                                                    <div class="flex flex-col bg-[#A35733] cursor-pointer" onClick={() => navigate("/allpost")}>
                                                        <div rel="noopener noreferrer" aria-label="Te nulla oportere reprimique his dolorum">
                                                            <img alt="" class="object-cover w-full h-52 bg-gray-500 dark:bg-gray-700" src={`${API_URL}${item?.postImage}`} />
                                                        </div>
                                                        <div class="flex flex-col flex-1 p-6">
                                                            <a href="#" class="text-xs tracking-wider uppercase hover:underline text-white">{item.title}</a>
                                                            <h3 class="flex-1 py-2 text-lg font-semibold leading-snug text-white">{item.program}</h3>
                                                            <div class="flex flex-wrap justify-between pt-3 space-x-2 text-xs text-gray-600 dark:text-gray-400">
                                                                <span className="text-white">{item.created_date}</span>
                                                                <span className="text-white">2.1K views</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        })}
                                    </div>
                                    <div className="flex justify-center" onClick={() => navigate("/allpost")}>
                                        <button className="inline-flex items-center hover:bg-[#A35733] py-2 px-6 text-black hover:text-white border border-[#A35733]">
                                            All Post
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
export default ProjectDetail;